import { render } from "./SearchHospitalModal.vue?vue&type=template&id=20738431&scoped=true"
import script from "./SearchHospitalModal.vue?vue&type=script&lang=js"
export * from "./SearchHospitalModal.vue?vue&type=script&lang=js"

import "./SearchHospitalModal.vue?vue&type=style&index=0&id=20738431&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20738431"]])

export default __exports__